import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { NgForm } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { isNil } from 'lodash';
import { CommonModule } from '@angular/common';
import { REMOVED, TestSetupModule } from '@nrwl/test-setup';
import { CommonMaterialModule } from '@nrwl/common-material';
import {
  TestLayerValue,
  CommonRegEx,
  DialogService,
  SchedulerFormat,
  SchedulerComponent,
  CommonLibModule,
  AGENT_MODEL,
  DevicesService,
  LicensesPageService
} from '@nrwl/common-lib';
import { Y1564SetupService } from '../../y1564-setup.service';
import {
  BaseSetupTab,
  IComponentStateHistory,
  IValueChangedEvent,
  outputParams
} from '@nrwl/test-setup';
import {
  TEST_MODE_TYPES,
  LAYER_TYPES,
  IPAddressLabel,
  STREAM_RATE_TYPE,
  PERF_TEST_DURATIONS,
  Y1564ConfigFieldMapping as ConfigFieldMapping,
  IPAddressValue,
  MTS_LAYER_TYPES,
  REVERSE_CONFIRM_SELECTION
} from '../../models/models';
import { ScheduleLicense } from '@nrwl/licenses';
@Component({
  selector: 'nrwl-y1564-setup',
  standalone: true,
  imports: [CommonModule, TestSetupModule, CommonMaterialModule, FormsModule, CommonLibModule],
  templateUrl: './y1564-setup.component.html',
  styleUrls: ['./y1564-setup.component.scss']
})
export class Y1564SetupComponent implements OnInit, OnDestroy {
  @Input() tab: BaseSetupTab;
  @Input() setupCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @typescript-eslint/ban-types
  @Input() restoreValues?: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  @Input() restoreAgentBasedConfig?: Function;
  @Input() previousOutput: outputParams;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();

  @ViewChild('setupForm', { static: true }) form: NgForm;
  @ViewChild(SchedulerComponent) schedulerChild: SchedulerComponent;
  configMapping = ConfigFieldMapping;
  newTestMode = true;
  customerName = '';
  contact = '';
  email = '';
  phone = '';
  technicianId = '';
  comments='';
  technicianName = '';
  testName = 'y1564';
  editMode = false;
  cloneMode = false;
  testInfo: any;
  config: any;
  outputs: Array<string>;
  stepPercentageDetails: string = null;
  validTestDurationRegex: RegExp = CommonRegEx.HH_MM_SS_REGEX;
  addingColonTwoCharRegex: RegExp = CommonRegEx.COLON_TWO_CHARACTORS;
  maxNumberOfSteps: Array<number> = [1, 2, 3, 4];
  testModes = TEST_MODE_TYPES;
  layerTypes = LAYER_TYPES;
  mtsLayerTypes = MTS_LAYER_TYPES;
  //ipAddressTypes = IP_ADDRESS_TYPE;
  ipAddressTypes = [];
  streamRateTypes = STREAM_RATE_TYPE;
  reverseStepOptions = REVERSE_CONFIRM_SELECTION;
  testDurationOptions = PERF_TEST_DURATIONS;
  customDuration = 900;
  setupFormField = {
    testMode: null,
    layerToTest: null,
    ipAddrType: null,
    streamRateConvention: null,
    configurationTest: true,
    stepsCount: null,
    stepPercents: null,
    stepDuration: null,
    reverseSteps: null,
    performanceTest: true,
    perfTestDuration: null,
    customPerfTestDuration: '00:15:00'
  };
  tabsubscription: Subscription;
  agentType = null;
  scheduler: SchedulerFormat;
  scheduleInfoData: SchedulerFormat = {
    repeatInterval: 0,
    timeStamp: '',
    endTime: '',
    isValid: true
  };
  isDisabledScheduler = false;
  schedulerEndsDurations = PERF_TEST_DURATIONS;
  schedulerEnds = {
    enabled: true,
    optionsList: PERF_TEST_DURATIONS
  };
  readonly unsubscribe: Subject<void> = new Subject();
  y1564ScheduleLicense = ScheduleLicense.Y1564;
  constructor(
    private readonly licenseService: LicensesPageService,
    public setupService: Y1564SetupService,
    private dialogService: DialogService,
    private readonly deviceService: DevicesService
  ) {}

  ngOnInit(): void {
    this.tab.form = this.form;
    this.schedulerEnds.optionsList = this.schedulerEndsDurations;
    this.initializeData();
    if (this.setupService.tabDataChangeEvents) {
      this.tabsubscription = this.setupService.tabDataChangeEvents.subscribe(event => {
        if (event === 0) {
          this.restoreFormValues();
        }
      });
    }
    this.licenseService.activeTestLicenseDetails.subscribe(licenseData => {
      if (licenseData?.length) {
        this.isDisabledScheduler = !licenseData.some(license =>
          this.y1564ScheduleLicense?.includes(license.featureName)
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.complete();
    this.unsubscribe.next();
    if (this.tabsubscription) {
      this.tabsubscription.unsubscribe();
    }
  }

  updateTestIdentity(event: {
    testName: string;
    customer: string;
    technician: string;
    isValidName: boolean;
    contact: string;
    email: string;
    phone: string;
    technicianId: string;
    comments: string;
  }): void {
    this.onDataEmit('alias', event.testName, event.isValidName);
    this.onDataEmit('customer', event.customer, true);
    this.onDataEmit('technician', event.technician, true);
    this.onDataEmit('contact', event.contact, true);
    this.onDataEmit('email', event.email, true);
    this.onDataEmit('phone', event.phone, true);
    this.onDataEmit('technicianId', event.technicianId, true);
    this.onDataEmit('comments',event.comments,true)
    const controls = this.form?.form?.controls;
    const allValid = controls ? Object.values(controls).every(control => !control.invalid) : true;
    const isFormValid = event.isValidName && allValid;
    this.form.form?.setErrors(isFormValid ? null : { invalid: true });
  }

  initializeData(): void {
    this.restoreAgentBasedConfig();
    this.restoreFormValues();
    this.newTestMode = this.setupService.mode === 'new';
    this.editMode = this.setupService.editMode;
    this.cloneMode = this.setupService.mode === 'clone';
    if (!this.newTestMode) {
      this.onTestModeChange();
    }
  }

  restoreFormValues(): void {
    this.tab.form = this.form;
    this.config = this.setupService.currentTab.config;
    this.outputs = this.config.def.outputs;
    this.ipAddressTypes = this.config.options[ConfigFieldMapping.IP_ADDRESS_TYPE].value;
    this.testName = this.restoreFieldValues(ConfigFieldMapping.ALIAS);
    this.customerName = this.restoreFieldValues(ConfigFieldMapping.CUSTOMER);
    this.technicianName = this.restoreFieldValues(ConfigFieldMapping.TECHINICIAN);
    this.contact = this.restoreFieldValues(ConfigFieldMapping.CONTACT);
    this.email = this.restoreFieldValues(ConfigFieldMapping.EMAIL);
    this.phone = this.restoreFieldValues(ConfigFieldMapping.PHONE);
    this.technicianId = this.restoreFieldValues(ConfigFieldMapping.TECHINICIANID);
    this.comments = this.restoreFieldValues(ConfigFieldMapping.COMMENTS);
    this.agentType = this.restoreFieldValues(ConfigFieldMapping.AGENT_TYPE) || 'default';
    if (this.deviceService.isMtsAgentModel(this.agentType)) {
      this.layerTypes = MTS_LAYER_TYPES;
      this.onDataEmit(ConfigFieldMapping.LAYER_TO_TEST, TestLayerValue.L4, true);
    } else {
      if (this.restoreFieldValues(ConfigFieldMapping.LAYER_TO_TEST) === TestLayerValue.L4) {
        this.onDataEmit(ConfigFieldMapping.LAYER_TO_TEST, TestLayerValue.L2, true);
      }
      this.layerTypes = LAYER_TYPES;
    }
    this.setupFormField.testMode = this.restoreFieldValues(ConfigFieldMapping.TEST_MODE);
    this.setupFormField.layerToTest = this.restoreFieldValues(ConfigFieldMapping.LAYER_TO_TEST);
    this.setupFormField.ipAddrType = this.restoreFieldValues(ConfigFieldMapping.IP_ADDRESS_TYPE);
    this.setupFormField.streamRateConvention = this.restoreFieldValues(
      ConfigFieldMapping.STREAM_RATE_CONVENTION
    );
    this.setupFormField.stepsCount = this.restoreFieldValues(ConfigFieldMapping.STEP_PERCENTS)
      ? this.restoreFieldValues(ConfigFieldMapping.STEP_PERCENTS).length + 1
      : 1;
    this.setupFormField.stepDuration = this.restoreFieldValues(ConfigFieldMapping.STEP_DURATION);
    this.setupFormField.reverseSteps = this.restoreFieldValues(ConfigFieldMapping.REVERSE_STEPS);
    this.setupFormField.perfTestDuration = this.restoreFieldValues(
      ConfigFieldMapping.PERF_TEST_DURATION
    );
    this.setupFormField.customPerfTestDuration = this.restoreFieldValues(
      ConfigFieldMapping.PERF_TEST_CUSTOM_DURATION
    );
    this.stepsPercentage(this.setupFormField.stepsCount);
    this.setupFormField.configurationTest = this.restoreFieldValues(
      ConfigFieldMapping.RUN_CONFIG_TEST
    );
    this.setupFormField.performanceTest = this.restoreFieldValues(ConfigFieldMapping.RUN_PERF_TEST);
    this.restoreScheduleParams(ConfigFieldMapping.SCHEDULER);
    this.checkCustomDuration();
  }

  checkCustomDuration(): void {
    const perfDuration = this.setupFormField.perfTestDuration;
    const isCustomDuration = !this.testDurationOptions.find(
      option => option.value === perfDuration
    );
    if (isCustomDuration) {
      this.setupFormField.perfTestDuration = 'custom';
      this.setupFormField.customPerfTestDuration = this.toTimeString(perfDuration);
      this.onPerfTestDurationChange();
    }
  }

  restoreFieldValues(field: string): any {
    const data = this.stateHistory(this.componentId, field);
    if (data && !isNil(data.value) && data.value !== REMOVED) {
      return data.value;
    }
    return null;
  }

  showFormField(field: string): boolean {
    return this.outputs.includes(field);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  onDataEmit(key: string, newValue: any, isValid: boolean): void {
    this.onDataValueChange.emit({
      componentId: this.componentId,
      key: key,
      newValue: newValue,
      isValid: isValid
    });
  }

  onLayerChange(): void {
    if (this.setupFormField.layerToTest === TestLayerValue.L4) {
      this.setupFormField.ipAddrType = IPAddressValue.IP_V4;
      this.ipAddressTypes = this.ipAddressTypes.filter(types => types.name != IPAddressLabel.IP_V6);
    } else if (
      this.setupFormField.layerToTest === TestLayerValue.L3 &&
      this.agentType?.toLowerCase()?.includes('jmep')
    ) {
      //ipv6 not supported for Jmep
      this.ipAddressTypes = this.ipAddressTypes.filter(types => types.name != IPAddressLabel.IP_V6);
      this.setupFormField.ipAddrType = IPAddressValue.IP_V4;
    } else {
      this.ipAddressTypes = this.config.options[ConfigFieldMapping.IP_ADDRESS_TYPE].value;
    }
    this.onDataEmit(ConfigFieldMapping.LAYER_TO_TEST, this.setupFormField.layerToTest, true);
  }

  onTestModeChange(): void {
    this.onDataEmit(ConfigFieldMapping.TEST_MODE, this.setupFormField.testMode, true);
    this.restoreAgentBasedConfig(this.agentType, this.setupFormField.testMode);
    this.restoreFormValues();
  }

  onIpAddressTypeChange(): void {
    this.onDataEmit(ConfigFieldMapping.IP_ADDRESS_TYPE, this.setupFormField.ipAddrType, true);
  }

  onStreamRateConventionChange(): void {
    this.onDataEmit(
      ConfigFieldMapping.STREAM_RATE_CONVENTION,
      this.setupFormField.streamRateConvention,
      true
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  performanceToggleChange($event: any): void {
    this.setupFormField.performanceTest = $event.checked;
    this.schedulerEnds.enabled = this.setupFormField.performanceTest;
    if (!this.setupFormField.performanceTest && !this.setupFormField.configurationTest) {
      $event.checked = true;
      this.setupFormField.performanceTest = true;
      this.dialogService.showInfo(
        'information',
        'body',
        'The configuration and performance tests cannot be turned off together. You must enable the configuration test before turning off performance test.',
        'Cannot disable'
      );
    } else {
      this.onDataEmit(ConfigFieldMapping.RUN_PERF_TEST, this.setupFormField.performanceTest, true);
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  configurationToggleChange($event: any): void {
    this.setupFormField.configurationTest = $event.checked;
    if (!this.setupFormField.configurationTest && !this.setupFormField.performanceTest) {
      $event.checked = true;
      this.setupFormField.configurationTest = true;
      this.dialogService.showInfo(
        'information',
        'body',
        'The configuration and performance tests cannot be turned off together. You must enable the performance test before turning off the configuration test.',
        'Cannot disable'
      );
    } else {
      this.onDataEmit(
        ConfigFieldMapping.RUN_CONFIG_TEST,
        this.setupFormField.configurationTest,
        true
      );
    }
  }

  convertHMStoSeconds(value: string): string {
    const hms = value.split(':');
    const hours = parseInt(hms[0], 10);
    const minutes = parseInt(hms[1], 10);
    const seconds = parseInt(hms[2], 10);
    const duration = hours * 3600 + minutes * 60 + seconds;
    if (!duration) {
      return value;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  reformatTestDuration(event: any) {
    if (event.data && event.target.value.length < 8) {
      event.target.value = event.target.value.replace(this.addingColonTwoCharRegex, '$1:');
    }
  }

  onNumberOfStepsChange(): void {
    this.stepsPercentage(this.setupFormField.stepsCount);
    this.onDataEmit(ConfigFieldMapping.NUMBER_OF_STEPS, this.setupFormField.stepsCount, true);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  stepsPercentage(steps: any): void {
    const stepsCount = parseInt(steps);
    const startPercent = Math.round(100 / stepsCount);
    const percent = '100%';
    let percetageString = '';
    const percentsArray: Array<string> = [];
    for (let i = 1; i < stepsCount; i++) {
      const stepPercent = String(startPercent * i);
      percentsArray.push(stepPercent);
      percetageString = percetageString + stepPercent;
      if (percetageString != '') {
        percetageString = percetageString + '-';
      }
    }
    this.setupFormField.stepPercents = percentsArray.length ? percentsArray : null;
    this.stepPercentageDetails = percetageString + percent;
    this.onDataEmit(ConfigFieldMapping.STEP_PERCENTS, this.setupFormField.stepPercents, true);
  }

  onReverseStepsChange(): void {
    this.onDataEmit(ConfigFieldMapping.REVERSE_STEPS, this.setupFormField.reverseSteps, true);
  }

  onStepDurationChange(): void {
    this.onDataEmit(ConfigFieldMapping.STEP_DURATION, this.setupFormField.stepDuration, true);
  }

  onPerfTestDurationChange(): void {
    let duration = null;
    if (this.setupFormField.perfTestDuration === 'custom') {
      duration = this.getTimeDurationInSeconds();
      this.onDataEmit(ConfigFieldMapping.PERF_TEST_DURATION, duration, true);
    } else {
      duration = this.setupFormField.perfTestDuration;
      this.onDataEmit(ConfigFieldMapping.PERF_TEST_DURATION, duration, true);
    }
  }

  customPerfTestDurationChange(): void {
    this.onPerfTestDurationChange();
    this.onDataEmit(
      ConfigFieldMapping.PERF_TEST_CUSTOM_DURATION,
      this.setupFormField.customPerfTestDuration,
      true
    );
  }

  getTimeDurationInSeconds(): number {
    let duration = this.customDuration;
    const hms = this.setupFormField.customPerfTestDuration.split(':');
    if (hms.length === 3) {
      const hours = parseInt(hms[0], 10);
      const minutes = parseInt(hms[1], 10);
      const seconds = parseInt(hms[2], 10);
      duration = Number(hours) * 60 * 60 + Number(minutes) * 60 + seconds;
    }
    return duration;
  }

  toTimeString(totalSeconds: number): string {
    const totalMs = totalSeconds * 1000;
    const result = new Date(totalMs).toISOString().slice(11, 19);
    return result;
  }

  restoreScheduleParams(field: string): void {
    const data = this.stateHistory(this.componentId, field);
    if (data && data.value !== REMOVED) {
      this.populateScheduler(data.value);
    }
  }

  populateScheduler(schedulerInfo: SchedulerFormat): void {
    this.scheduleInfoData.repeatInterval = schedulerInfo.repeatInterval;
    this.scheduleInfoData.timeStamp = schedulerInfo.timeStamp;
    //this.scheduleInfoData.endTime = schedulerInfo.endTime;
    this.scheduleInfoData.endTime = this.setupFormField.perfTestDuration;
    this.scheduleInfoData.isValid = schedulerInfo.isValid;
    this.emitScedulerParams();
  }

  //** get scheduler param values from scheduler component */
  fetchSchedulerVal(event: SchedulerFormat): void {
    this.scheduler = event;
    this.scheduleInfoData.repeatInterval = event.repeatInterval;
    this.scheduleInfoData.timeStamp = this.setupService.getScheduleTimeStamp(event.timeStamp);
    this.scheduleInfoData.isValid = event.isValid;
    this.scheduleInfoData.endTime = event.endTime;
    if (this.scheduleInfoData.endTime) {
      this.onDataEmit(ConfigFieldMapping.PERF_TEST_DURATION, this.scheduleInfoData.endTime, true);
    }
    this.emitScedulerParams();
  }

  emitScedulerParams(): void {
    this.onDataEmit('scheduler', this.scheduleInfoData, this.scheduleInfoData.isValid);
  }
}
